<template>
  <div>
    <v-breadcrumbs :items="items" divider=">"></v-breadcrumbs>
    <v-flex text-xs-center>
      <Title :title="game.title"></Title>
    </v-flex>
    <v-flex xs12 offset-sm1 sm10 offset-md1 md10 lg8 offset-lg2 xl6 offset-xl3>
      <GameOrganism :game="game" @go-to-platform="$emit('go-to-platform', $event)"></GameOrganism>
    </v-flex>
    <AddScoreButton v-on:add-score="$emit('add-score', game.id)"></AddScoreButton>
  </div>
</template>

<script>
  import GameOrganism from '@/components/organisms/Game.vue';
  import Title from '@/components/atoms/Title.vue';
  import AddScoreButton from '@/components/atoms/AddScoreButton.vue';

  export default {
    components: { GameOrganism, Title, AddScoreButton },
    props: ['game', 'platform'],
    computed: {
      items() {
        let items = [
          {
            text: 'Accueil',
            disabled: false,
            href: '/',
          },
        ];

        if (this.platform) {
          items = items.concat([
            {
              text: 'Platformes',
              disabled: false,
              href: '/platforms',
            },
            {
              text: this.platform,
              disabled: false,
              href: `/platforms/${this.platform}`,
            },
          ]);
        } else {
          items = items.concat([
            {
              text: 'Jeux',
              disabled: false,
              href: '/games',
            },
          ]);
        }

        items = items.concat([{ text: this.game.title, disabled: true, href: '' }]);

        return items;
      },
    },
  };
</script>
